import authRoutes from '@/modules/auth/auth.routes';
import homeRoutes from '@/modules/home/home.routes';
import errorRoutes from '@/modules/error/error.routes';
import articleRoutes from '@/modules/article/article.routes';
import trackRoutes from '@/modules/track/track.routes';
import questionRoutes from '@/modules/question/question.routes';
import tagRoutes from '@/modules/tag/tag.routes';
import settingRoutes from '@/modules/setting/setting.routes';
import companyRoutes from '@/modules/company/company.routes';
import departmentRoutes from '@/modules/department/department.routes';
import userRoutes from '@/modules/user/user.routes';
import mySpaceRoutes from '@/modules/my-space/my-space.routes';
import notificationRoutes from '@/modules/notification/notification.routes';

const routes = [
  {
    path: '*',
    redirect: '/',
  },
];

export default [
  ...routes,
  ...homeRoutes,
  ...authRoutes,
  ...errorRoutes,
  ...mySpaceRoutes,
  ...articleRoutes,
  ...questionRoutes,
  ...tagRoutes,
  ...settingRoutes,
  ...companyRoutes,
  ...trackRoutes,
  ...departmentRoutes,
  ...notificationRoutes,
  ...userRoutes,
];
